import React from "react";

const PREFIX = "deal-rush-crouton";
export const DEAL_RUSH_CROUTON_DATA_TEST_IDS = {
    CONTAINER: `${PREFIX}-container`,
    TEXT: `${PREFIX}-text`,
};

export const CLOSE_ICON_CSS_PROPERTIES: React.CSSProperties = {
    background: "none",
    margin: "0 8px 0 12px",
    display: "flex",
    alignItems: "center",
};

export const DEAL_RUSH_OFFER = "dealrush";
